// Class: haxe.xml._Access.NodeAccess_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function Xml() {return require("./../../../Xml");}
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}
function _$Xml_XmlType_$Impl_$() {return require("./../../../_Xml/XmlType_Impl_");}

// Constructor

var NodeAccess_Impl_ = function(){}

// Meta

NodeAccess_Impl_.__name__ = "haxe.xml._Access.NodeAccess_Impl_";
NodeAccess_Impl_.__isInterface__ = false;
NodeAccess_Impl_.prototype = {
	
};
NodeAccess_Impl_.prototype.__class__ = NodeAccess_Impl_.prototype.constructor = $hxClasses["haxe.xml._Access.NodeAccess_Impl_"] = NodeAccess_Impl_;

// Init



// Statics

NodeAccess_Impl_.resolve = function(this1,name) {
	var x = this1.elementsNamed(name).next();
	if(x == null) {
		var xname = this1.nodeType == (Xml().default).Document ? "Document" : this1.get_nodeName();
		throw new (js__$Boot_HaxeError().default)(xname + " is missing element " + name);
	}
	if(x.nodeType != (Xml().default).Document && x.nodeType != (Xml().default).Element) {
		throw new (js__$Boot_HaxeError().default)("Invalid nodeType " + (_$Xml_XmlType_$Impl_$().default).toString(x.nodeType));
	}
	var this2 = x;
	return this2;
}


// Export

exports.default = NodeAccess_Impl_;